import request from "../../request";

/**
 *  积分商城---查询商品分页
 */
export function selectProductPage(query) {
    return request({
        url: 'sys/PointsMall/GetPointsMallByPage',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 *  积分商城---新增商品、编辑商品
 */
export function insertProduct(item) {
    return request({
        url: 'sys/PointsMall/insertPointsMall',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}


/**
 *  查询兑换明细
 */
export function selectExchangeDetail(query) {
    return request({
        url: 'sys/PointsMall/GetPointsMallOut',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

export function exchangeDetailExcel(query) {
    return request({
        url: 'sys/PointsMall/GetPointsMallOutExcel',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 *  查询全部商品 -- 商品兑换功能--选择商品接口
 */
export function selectAllProduct(query) {
    return request({
        url: 'sys/PointsMall/GetAllPointsMall',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 *  商品兑换功能
 */
export function exchangeProduct(item) {
    return request({
        url: 'sys/PointsRuleLibraryWeb/RedeemPoints',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}